// extracted by mini-css-extract-plugin
module.exports =  {"container":"EditColumnsModal-k9s8__container"};